module.exports = __webpack_public_path__ + "img/SKYvsOTP.d2fa7e5c.png";